<template>
  <modal name="certReg" v-bind:width="400" v-bind:height="232" v-on:before-open="beforeOpen" v-on:before-close="beforeClose">
    <div class="certRegModalWrapper">
      <div class="certRegModalHeader">
        <img v-bind:src="closeIcon" v-on:click="modalClose">
      </div>
      <div class="certRegModalTextDiv">
        <span>{{text}}</span>
      </div>
      <div class="certRegModalFileDiv">
        <input type="file" class="inputFileHidden" ref="imageInput" id="inputFileBtn" accept="image/*" v-on:change="getFileInfo">
        <span>{{fileName}}</span>
        <label for="inputFileBtn">찾기</label>
      </div>
      <span class="validText" v-if="error != null">{{error}}</span>
      <div class="certRegModalBtnDiv">
        <button class="uploadBtn" v-bind:disabled="!isImageSet" v-on:click="modifyCertImg">업로드하기</button>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  data () {
    return {
      type: null,
      text: '',
      fileName: '',
      error: null,
      certFile: null,
      closeIcon: null
    }
  },
  methods: {
    modalClose: function () {
      this.$modal.hide('certReg')
    },
    getFileInfo: function (e) {
      let pathPoint = e.target.files[0].name.lastIndexOf('.')
      let fileType = e.target.files[0].name.substring(pathPoint + 1, e.target.files[0].name.length).toLowerCase()

      if (fileType === 'jpg' || fileType === 'jpeg' || fileType === 'gif' || fileType === 'png' || fileType === 'bmp' || fileType === '') {
        this.error = null
        const file = e.target.files[0]
        this.fileName = e.target.files.length === 0 ? '' : file.name
        this.certFile = file
      }else {
        this.error = '* 이미지 형식의 파일을 선택 해 주세요.'
      }
    },
    modifyCertImg: async function () {
      try {
        if (this.$store.getters.getAdUserStateValue('certificate') != null && this.$store.getters.getAdUserStateValue('certificate') !== '') {
          // 이미 사업자 등록증 이미지가 있을 경우 기존 사업자 등록증 삭제
          await this.$store.dispatch('deleteAdUserCertImageApi')
        }
        // 사업자 등록증 이미지 등록
        await this.$store.dispatch('saveAdUserCertImageApi', {certFile: this.certFile})
        // 광고주 정보 갱신
        await this.$store.dispatch('adUserInfoApi')
        // 모달창 닫기
        this.modalClose()
      } catch (error) {
        console.log(error.response)
      }
    },
    beforeOpen: function (event) {
      // 텍스트 셋팅
      this.type = event.params.type
      this.text = event.params.type === 'register' ? '사업자등록증 등록' : '사업자등록증 편집'
      this.fileName = event.params.type === 'register' ? '업로드된 파일이 없습니다.' : '파일 업로드 완료'
    },
    beforeClose: function () {
      this.fileName = ''
      this.error = null
      this.certFile = null
    }
  },
  created: function () {
    this.closeIcon = require('@/assets/img/modal_close_icon.png')
  },
  computed: {
    isImageSet: function () {
      return !!(this.certFile != null && this.certFile !== '')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.certRegModalWrapper{
  display : -webkit-flex;
  display: flex;
  flex-direction: column;
  padding: 0px;
}


.certRegModalHeader{
  display : -webkit-flex;
  display: flex;
  justify-content: flex-end;
  height: 32px;
  padding: 6px 6px 0 0;
}

.certRegModalHeader > img {
  cursor: pointer;
  height: 100%;
  width: auto;
}

.certRegModalWrapper > span{
  margin: 0 32px;
  color: red;
  font-size: 10px;
}

.certRegModalTextDiv {
  padding: 0 32px 18px 32px;
}

.certRegModalTextDiv > span {
  font-size: 24px;
}

.certRegModalFileDiv{
  display : -webkit-flex;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 32px 18px 32px;
  height: 44px;
  border: 1px solid black;
}

.certRegModalFileDiv > label{
  cursor: pointer;
  margin: auto 10px;
  padding: 5px 10px;
  border-radius: 0.5rem;
  font-size: 13px;
  font-weight: bold;
  color: white;
  background-color: rgb(0,153,255);
}

.certRegModalFileDiv > span{
  margin-left: 10px;
  font-size: 13px;
}

.inputFileHidden{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip:rect(0,0,0,0);
  border: 0;
}

.certRegModalBtnDiv{
  display : -webkit-flex;
  display: flex;
  justify-content: center;
  padding: 0 30px 0 30px;
}

.certRegModalBtnDiv > button {
  cursor: pointer;
  font-size: 15px;
  font-weight: bold;
  padding: 5px 10px;
  border-radius: 0.25rem;
  color: white;
  border: none;
  outline: none;
  height: 48px;
  width: 200px;
}

.uploadBtn {
  background-color: rgb(0,153,255);
}

.uploadBtn:disabled{
  cursor: default;
  background-color: rgb(207,207,207);
}
</style>



// WEBPACK FOOTER //
// src/components/board/elements/certificateRegistrationModal.vue